import { matchPath } from 'react-router-dom';

export const isRouteDisabled = (path: string, disabledPaths: readonly string[] = []) =>
    disabledPaths.some(pattern => Boolean(matchPath({path: pattern, end:false}, path)));

/** The most specific assigned route wins, including an explicit denial. */
export const canAccessRoute = (path: string, role: string | null | undefined, permissions: Record<string, string[]>, disabledPaths: readonly string[] = []): boolean => {
    if (isRouteDisabled(path, disabledPaths)) return false;
    const candidates = Object.keys(permissions).filter(pattern => matchPath({path: pattern, end:false}, path))
        .sort((a, b) => {
            const weight = (pattern: string) => pattern.split('/').filter(part => part && !part.startsWith(':') && part !== '*').length * 1000 + pattern.length;
            return weight(b) - weight(a);
        });
    const normalized = (role || '').trim().toLowerCase();
    return Boolean(normalized && candidates.length && permissions[candidates[0]].some(allowed => allowed.trim().toLowerCase() === normalized));
};
